import React, { useEffect, useState } from 'react';
export function StickyHeader() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight * 0.7;
      setVisible(window.scrollY > heroHeight);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCTA = () => {
    const el = document.getElementById('money-cta');
    if (el) el.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <div className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`} data-id="element-268">
      <div className="bg-navy/70 backdrop-blur-md border-b border-gold/10" data-id="element-269">
        <div className="max-w-4xl mx-auto px-4 py-2.5 flex items-center justify-center" data-id="element-270">
          <button onClick={scrollToCTA} className="bg-gold text-navy font-semibold text-xs md:text-sm px-5 md:px-8 py-2 md:py-2.5 rounded-full transition-transform duration-300 hover:scale-105 hover:shadow-lg hover:shadow-gold/20" data-id="element-271">
            Understand Your Spending
          </button>
        </div>
      </div>
    </div>;
}